import { render, staticRenderFns } from "./data-path.vue?vue&type=template&id=6fbb0ce4&"
import script from "./data-path.vue?vue&type=script&lang=js&"
export * from "./data-path.vue?vue&type=script&lang=js&"
import style0 from "./data-path.vue?vue&type=style&index=0&id=6fbb0ce4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports